import { ActionTypes, IState } from "./types";
import {
  DELETE_LOGO_ERROR,
  DELETE_LOGO_REQUEST,
  DELETE_LOGO_SUCCESS,
  FETCH_LOGO_ERROR,
  FETCH_LOGO_REQUEST,
  FETCH_LOGO_SUCCESS,
  UPLOAD_LOGO_ERROR,
  UPLOAD_LOGO_REQUEST,
  UPLOAD_LOGO_SUCCESS,
  initialState,
} from "./constants";

const reducer = (prevState: IState, action: ActionTypes) => {
  const state = prevState || initialState;

  switch (action.type) {
    case FETCH_LOGO_REQUEST:
      return { ...state, isFetching: true, error: undefined };
    case FETCH_LOGO_SUCCESS:
      return {
        ...state,
        isFetching: false,
        logoUrl: action.payload?.url,
        dimensionWarnings: action.payload?.dimensionWarnings,
        error: undefined,
      };
    case FETCH_LOGO_ERROR:
      return { ...state, isFetching: false, error: action.payload };
    case UPLOAD_LOGO_REQUEST:
      return { ...state, isUploading: true, error: undefined };
    case UPLOAD_LOGO_SUCCESS:
      return {
        ...state,
        isUploading: false,
        logoUrl: action.payload?.url,
        dimensionWarnings: action.payload?.dimensionWarnings,
        error: undefined,
      };
    case UPLOAD_LOGO_ERROR:
      return { ...state, isUploading: false, error: action.payload };
    case DELETE_LOGO_REQUEST:
      return { ...state, isDeleting: true, error: undefined };
    case DELETE_LOGO_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        logoUrl: undefined,
        dimensionWarnings: undefined,
        error: undefined,
      };
    case DELETE_LOGO_ERROR:
      return { ...state, isDeleting: false, error: action.payload };
    default:
      return state;
  }
};

export default reducer;
